var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{key:_vm.repo.id,class:_vm.packageClass,attrs:{"to":{ name: _vm.repoRouteName, params: { repoId: _vm.repo.id}},"data-automation":("repo-link-" + (_vm.repo.id))}},[_vm._v("\n  "+_vm._s(_vm.repo.name)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }